import React from 'react';
import {Route , Switch, BrowserRouter} from 'react-router-dom';
import PanelHomePage from './pages/panelHomepage/PanelHomepage';
import RegressionPage from "./pages/regression/RegressionPage";
import ImageMenuPage from "./pages/imageClassification/ImageMenuPage";
import OverfittingPage from "./pages/imageClassification/overfitting/OverfittingPage";
import UnderfittingPage from "./pages/imageClassification/underfitting/UnderfittingPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <div>
      <BrowserRouter>
    <Switch>
    <Route exact path='/' component= {PanelHomePage}></Route>
    <Route exact path='/poly' component= {RegressionPage}></Route>
    <Route exact path='/images' component= {ImageMenuPage}></Route>
    <Route exact path='/overfitting' component= {OverfittingPage}></Route>
    <Route exact path='/underfitting' component= {UnderfittingPage}></Route>
    <Route exact path='/contact' component= {ContactPage}></Route>
    </Switch>
    </BrowserRouter>
  </div>
  );
}

export default App;
